import type { FC } from 'react';
import { Card } from '@material-ui/core';
import { Box } from '@material-ui/system';
import Chart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';

const CurvaProduccionChartLineIngreso: FC<{ headers: any[], data: any, title: string }> = ({ headers, data, title }) => {
  const evolutivo = {
    labels: headers.map((item) => item.label),
    values: {
      fcst: [...data.fcstIngresoA],
      real: [...data.realIngresoA],
    }
  };

  const chart: { series: any; options: ApexOptions } = {
    options: {
      chart: {
        stacked: false,
        toolbar: {
          show: true,
        },
        animations: {
          enabled: false,
        },
      },
      colors: ['#eb7d30', '#166aaa'],
      plotOptions: {
        bar: {
          distributed: false,
          horizontal: false,
        },
      },
      markers: {
        size: 5,
      },
      dataLabels: {
        enabled: true,
        background: {
          enabled: false,
          dropShadow: undefined,
        },
        style: {
          fontSize: '9px',
          colors: ['#eb7d30', '#166aaa'],
        },
        offsetY: -5,
        formatter: (value) => `${value}M`,
      },
      title: {
        text: title,
        align: 'center',
        style: {
          fontSize: '13px',
          color: 'gray'
        }
      },
      xaxis: {
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: true,
        },
        categories: [...evolutivo.labels],
        labels: {
          style: {
            fontSize: '10px',
            colors: 'gray',
          }
        },
      },
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
      legend: {
        show: true,
        floating: false,
        position: 'bottom',
        fontSize: '9px',
      },
    },
    series: [
      {
        name: 'Fcst Acumulado (S/.)',
        data: [...evolutivo.values.fcst],
      },
      {
        name: 'Real Acumulado (S/.)',
        data: [...evolutivo.values.real],
      },
    ],
  };

  return (
    <>
      <Box>
        <Card style={{ paddingRight: '20px', paddingTop: '7px' }}>
          <Chart type="line" height="450" {...chart} />
        </Card>
      </Box>
    </>
  );
};

export default CurvaProduccionChartLineIngreso;
